import React, { useState } from 'react';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useDispatch } from 'react-redux';
import Strings from '../../i18n';
import { Header } from '../../components/header/header';
import { UsersByLocationTemplate } from '../../templates/locations/usersByLocation/usersByLocationTemplate';
import { ButtonIconStyled } from '../users/usersViewStyles';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import { TitleStyled } from '../devices/devicesStyles';
import { ContainerStyled } from '../locations/locationStyles';
import SearchButton from '../../components/commons/SearchButton/SearchButton';
import { IUserInfo } from '../../types/Auth/authInterface';

export const UserByLocationView = () => {
  const dispatch = useDispatch();
  const [openSideBar, setOpenSideBar] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<IUserInfo[]>([]);

  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.editUserPermissions
  );
  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };
  const [searchValue, setSearchValue] = useState('');

  return (
    <div>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left" />
            <div className="col-4 text-center">
              <TitleStyled>{Strings.users.users}</TitleStyled>
            </div>
            <div className="col-4 text-right">
              <ButtonIconStyled
                size="small"
                onClick={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.addUserToLocation
                  );
                }}
              >
                <PersonAddAltIcon />
              </ButtonIconStyled>
            </div>
          </div>
        </ContainerStyled>
      </Header>
      <UsersByLocationTemplate
        sideBarOpenFor={sideBarOpenFor}
        openRightSideBarForMethod={openRightSideBarForMethod}
        openedSideBar={openSideBar}
        setOpenSideBar={setOpenSideBar}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
      />
    </div>
  );
};
